import { PivotFilterOperatorEnum } from '@ztechapps/common.contract'

const O = PivotFilterOperatorEnum

/** The eight operators a Value comparison takes, in the dialog's order. */
export const PIVOT_VALUE_COMPARISON_OPERATORS: PivotFilterOperatorEnum[] = [
  O.equal,
  O.not_equal,
  O.greater,
  O.greater_equal,
  O.less,
  O.less_equal,
  O.between,
  O.not_between,
]
